/**
 * Extracts the MojeID login URL from the hidden `.comment-form-login-mojeid` element
 * and injects a styled login button into `.form-submit`, allowing unauthenticated users
 * to log in via MojeID directly from the comment form without going through moderation.
 */
const initNiaApprovedComment = () => {
    const commentForm = document.querySelector('#commentform')

    if (!commentForm) return

    const loginMojeid = commentForm.querySelector('.comment-form-login-mojeid')
    const loginAnchor = loginMojeid?.querySelector('a')
    const loginLink = loginAnchor?.getAttribute('href')

    if (!loginLink) return

    // The actual login is handled by the injected button below, so repoint the
    // inline "MojeID" link to the informational how-to page.
    loginAnchor.href = 'https://www.mojeid.cz/cs/jak-na-to/'
    loginAnchor.target = '_blank'
    loginAnchor.rel = 'noopener'

    const formSubmit = commentForm.querySelector('.form-submit')

    if (!formSubmit) return

    const button = document.createElement('a')

    button.href = loginLink
    button.classList.add('login-mojeid', 'btn')
    button.textContent = 'Přihlásit přes MojeID'

    formSubmit.prepend(button)
}

/**
 * Detects whether the current page contains a comment awaiting moderation (WordPress sets
 * comment_approved=0 and renders `.comment-awaiting-moderation`) and inserts a dismissible
 * Bootstrap info alert above the comment form to inform the user.
 */
const initCommentModerationNotice = () => {
    if (!document.querySelector('.comment-awaiting-moderation')) return

    const formSubmit = document.querySelector('#commentform .form-submit')

    if (!formSubmit) return

    const alert = document.createElement('div')

    alert.className = 'alert alert-success alert-dismissible'
    alert.style.gridColumn = '1 / -1'
    alert.setAttribute('role', 'alert')
    alert.innerHTML = 'Děkujeme! Komentář se zobrazí po schválení moderátorem.'
        + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Zavřít"></button>'

    formSubmit.before(alert)
}

const validateField = (field) => {
    const value = field.value.trim()
    if (!value) return 'Toto pole je povinné.'
    if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Zadejte platnou e-mailovou adresu.'
    return null
}

const initCommentValidation = () => {
    const commentForm = document.querySelector('#commentform')
    if (!commentForm) return

    const fields = Array.from(commentForm.querySelectorAll('[aria-required="true"]'))
    if (!fields.length) return

    fields.forEach((field) => {
        const errorMsg = document.createElement('div')
        errorMsg.className = 'invalid-feedback'
        field.after(errorMsg)

        field.addEventListener('input', () => {
            const error = validateField(field)
            if (!error) {
                field.classList.remove('is-invalid')
                errorMsg.textContent = ''
            }
        })
    })

    commentForm.addEventListener('submit', (e) => {
        let firstInvalid = null

        fields.forEach((field) => {
            const error = validateField(field)
            const errorMsg = field.nextElementSibling
            if (error) {
                field.classList.add('is-invalid')
                errorMsg.textContent = error
                if (!firstInvalid) firstInvalid = field
            } else {
                field.classList.remove('is-invalid')
                errorMsg.textContent = ''
            }
        })

        if (firstInvalid) {
            e.preventDefault()
            firstInvalid.focus()
        }
    })
}

export { initNiaApprovedComment, initCommentModerationNotice, initCommentValidation }
